import {
  ADD_SUBMISSION_DATA_SIGNET,
  ADD_SUBMISSION_DATA_SIGNET_START,
  ADD_SUBMISSION_DATA_SIGNET_ERROR,
  GET_SUBMISSION_DATA_SIGNET_BY_SIGNET,
  GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_START,
  GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_ERROR,
  CLEAR_ERROR_SUBMISSION_DATA_SIGNET,
  ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK,
  ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_START,
  ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_ERROR,
} from '../actions/types';

const initialState = {
  submissionDataSignetList: [],
  submissionDataSignet: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addSubmissionDataSignetStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const addSubmissionDataSignetError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addSubmissionDataSignet = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetList: state.submissionDataSignetList.concat(
      action.payload
    ),
    error: undefined,
  };
};

const addSubmissionDataSignetWithLookStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const addSubmissionDataSignetWithLookError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addSubmissionDataSignetWithLook = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetList: state.submissionDataSignetList.concat(
      action.payload
    ),
    error: undefined,
  };
};

const findSubmissionDataSignetBySignet = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignet: action.payload,
    error: undefined,
  };
};

const findSubmissionDataSignetBySignetStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findSubmissionDataSignetBySignetError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_SUBMISSION_DATA_SIGNET:
      return addSubmissionDataSignet(state, action);
    case ADD_SUBMISSION_DATA_SIGNET_START:
      return addSubmissionDataSignetStart(state);
    case ADD_SUBMISSION_DATA_SIGNET_ERROR:
      return addSubmissionDataSignetError(state, action);

    case ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK:
      return addSubmissionDataSignetWithLook(state, action);
    case ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_START:
      return addSubmissionDataSignetWithLookStart(state);
    case ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_ERROR:
      return addSubmissionDataSignetWithLookError(state, action);

    case GET_SUBMISSION_DATA_SIGNET_BY_SIGNET:
      return findSubmissionDataSignetBySignet(state, action);
    case GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_START:
      return findSubmissionDataSignetBySignetStart(state, action);
    case GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_ERROR:
      return findSubmissionDataSignetBySignetError(state, action);

    case CLEAR_ERROR_SUBMISSION_DATA_SIGNET:
      return clearError(state);
    default:
      return state;
  }
}
